import {
  TrophyIcon,
  FileTextIcon,
  CardsIcon,
  BellIcon,
  PhoneIcon,
  GlobeIcon,
  SlackLogoIcon,
  EyeSlashIcon,
  QuestionIcon,
  ChatsCircleIcon,
  BookOpenIcon,
  BriefcaseIcon,
} from '@phosphor-icons/react';

import type { Icon } from '@phosphor-icons/react';

const SOURCE_TYPE_ICON_MAP: Record<string, Icon> = {
  WIN_LOSS: TrophyIcon,
  INTERNAL_DOCUMENTS: FileTextIcon,
  CARDS: CardsIcon,
  ALERTS: BellIcon,
  CALL_TRANSCRIPTS: PhoneIcon,
  WEB_SEARCH: GlobeIcon,
  SLACK: SlackLogoIcon,
  AUTO_INSIGHTS: FileTextIcon,
  BLINDSPOTS: EyeSlashIcon,
  MESSAGES: ChatsCircleIcon,
  AGENT_ARTIFACTS: BookOpenIcon,
  DEAL_CONTEXT: BriefcaseIcon,
  UNKNOWN: FileTextIcon,
};

export const getSourceIcon = (sourceType: string): Icon => {
  return SOURCE_TYPE_ICON_MAP[sourceType] ?? QuestionIcon;
};

export const SOURCE_TYPE_ICONS = new Proxy(SOURCE_TYPE_ICON_MAP, {
  get: (target, prop: string) => target[prop] ?? QuestionIcon,
}) as Record<string, Icon>;
